import React from 'react';
import { Image } from 'react-native';

class FastImage extends React.Component {
    static resizeMode = {
        cover : 'cover',
        stretch : 'stretch',
        center : 'center',
        contain: 'contain',
    }
    render = () => {
        return (
            <Image {...this.props} />
        );
    }
    static cacheControl = { web: '' }
}

export default FastImage;
